/*
**************************** 
홈페이지 콘텐츠 - 놀이교육
*****************************
*/

import React from "react";

export default function Entertainment() {

    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb ">
                    <li className="breadcrumb-item small"><a href="#">톡톡박스</a></li>
                    <li className="breadcrumb-item active small">엔터테인먼트</li>
                </ol>
            </div>

            <main className=".main">
                <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item medium" role="presentation">
                        <a className="nav-link active text-muted text-decoration-none" data-bs-toggle="tab" href="#play" aria-selected="true" role="tab" tabindex="-1">놀이교육</a>
                    </li>
                </ul>
                <div id="myTabContent" className="tab-content">
                    <div className="tab-pane  active show" id="play" role="tabpanel">
                    </div>
                    <div>
                        <img className="img-fluid" src="/img/school/cookids.png" alt="" />
                    </div>
                </div>
            </main>
        </div>
    )
}